import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import { url, auth_key, user_id } from "../../../constants";
import { Typography, Button } from "@material-ui/core";
import { useSelector } from "react-redux";

const getChart = async (query, filters, period, ISINString) => {
  try {
    const response = await axios.post(
      `${url}/portfolioindex`,

      {
        ...filters,
        Query: query,
        period: period,
        ISIN_Selected: ISINString,
      },
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const IndexGraph = (props) => {
  const [historical_data, setHistorical_data] = useState([]);
  const [dateLabels, setDateLabels] = useState([]);
  const [name, setName] = useState("");
  const query = props.query;
  const filters = props.filters;
  const t = props.t;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const [period, setPeriod] = useState("1mo");

  useEffect(async () => {
    if (query) {
      const _dataset = await getChart(query, filters, period, "20");
      var dataArray = [];
      var dateArray = [];
      _dataset?.theme_index?.map((item) => {
        dataArray.push(item.normalize);
        const labels = item.Date.split("-");
        dateArray.push(`${labels[1]}.${labels[0]}.`);
      });
      setHistorical_data([...dataArray]);
      setDateLabels([...dateArray]);
    }
  }, [query, filters, period]);

  const data = () => {
    return {
      labels: [...dateLabels],
      datasets: [
        {
          data: [...historical_data],
          fill: false,
          borderColor: "#0040ff",
          pointRadius: 0,
          lineTension: 0.1,
          borderWidth: 2,
        },
      ],
    };
  };

  return (
    <>
      {query && historical_data?.length > 0 ? (
        <>
          <Typography
            variant="h5"
            style={{
              fontFamily: "Overpass",
              margin: "0 0 20px 20px",
              fontSize: "21px",
              fontWeight: 900,
              marginLeft: isDesktopOrLaptop ? "341px" : "10px",
              color: "#16063b",
              textTransform: "capitalize",
            }}
          >
            {`${t("stoqqy_trend")} ${query}`}:
          </Typography>
          <div
            style={{
              display: "flex",
              width: "100%",
              marginLeft: isDesktopOrLaptop ? "341px" : "10px",
              alignItems: "center",
            }}
          >
            {isDesktopOrLaptop ? (
              <div style={{ width: "50px", marginRight: "20px" }}>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "20px",
                    borderRadius: "25px",
                    fontFamily: "Overpass",
                    color: period === "1mo" ? "#f8f8f8" : "#808080",
                    backgroundColor: period === "1mo" ? "#0040ff" : "#f8f8f8",
                  }}
                  onClick={() => {
                    setPeriod("1mo");
                  }}
                >
                  1mo
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "20px",
                    borderRadius: "25px",
                    marginTop: "10px",
                    fontFamily: "Overpass",
                    color: period === "ytd" ? "#f8f8f8" : "#808080",
                    backgroundColor: period === "ytd" ? "#0040ff" : "#f8f8f8",
                  }}
                  onClick={() => {
                    setPeriod("ytd");
                  }}
                >
                  ytd
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "20px",
                    borderRadius: "25px",
                    fontFamily: "Overpass",
                    marginTop: "10px",
                    color: period === "all" ? "#f8f8f8" : "#808080",
                    backgroundColor: period === "all" ? "#0040ff" : "#f8f8f8",
                  }}
                  onClick={() => {
                    setPeriod("all");
                  }}
                >
                  ALL
                </Button>
              </div>
            ) : null}
            <div
              style={{
                width: isDesktopOrLaptop ? "687px" : "100%",
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  width: "99.99%",
                }}
              >
                <Line
                  data={data}
                  legend={{
                    display: false,
                  }}
                  options={{
                    responsive: true,

                    maintainAspectRatio: false,
                    // layout: {
                    //   padding: 20,
                    // },
                    scales: {
                      xAxes: [
                        {
                          gridLines: {
                            display: false,
                          },
                          ticks: {
                            maxRotation: 0,
                            maxTicksLimit: isDesktopOrLaptop ? 5 : 3,
                            fontSize: 10,
                          },
                        },
                      ],
                      yAxes: [
                        {
                          gridLines: {
                            display: true,
                            color: "#fafbfb",
                            zeroLineColor: "#fafbfb",
                          },
                          ticks: {
                            maxTicksLimit: isDesktopOrLaptop ? 5 : 3,
                            stepSize:
                              data?.max - data?.min > 10
                                ? Math.floor((data?.max - data?.min) / 5)
                                : (data?.max - data?.min) / 8,
                            fontSize: 10,
                            callback: function (value, index, values) {
                              return value + "%";
                            },
                          },
                        },
                      ],
                    },
                  }}
                />
              </div>
            </div>
          </div>
          {isDesktopOrLaptop ? null : (
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                size="small"
                variant="contained"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  fontFamily: "Overpass",
                  color: period === "1mo" ? "#f8f8f8" : "#808080",
                  backgroundColor: period === "1mo" ? "#0040ff" : "#f8f8f8",
                }}
                onClick={() => {
                  setPeriod("1mo");
                }}
              >
                1mo
              </Button>
              <Button
                size="small"
                variant="contained"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  fontFamily: "Overpass",
                  marginLeft: "10px",
                  color: period === "ytd" ? "#f8f8f8" : "#808080",
                  backgroundColor: period === "ytd" ? "#0040ff" : "#f8f8f8",
                }}
                onClick={() => {
                  setPeriod("ytd");
                }}
              >
                ytd
              </Button>
              <Button
                size="small"
                variant="contained"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "20px",
                  borderRadius: "25px",
                  fontFamily: "Overpass",
                  marginLeft: "10px",
                  color: period === "all" ? "#f8f8f8" : "#808080",
                  backgroundColor: period === "all" ? "#0040ff" : "#f8f8f8",
                }}
                onClick={() => {
                  setPeriod("all");
                }}
              >
                ALL
              </Button>
            </div>
          )}
          <div
            className="GreyLine"
            style={{
              margin: isDesktopOrLaptop ? "30px 98px" : "30px 0",
            }}
          ></div>
        </>
      ) : null}
    </>
  );
};

export default IndexGraph;
